//photography card - interface & navigate
import { useNavigate } from 'react-router-dom';
import './photographcss.css';
import LoadingSpinner from '../../utility/LoadingSpinner';

function Photographcard({ title, id }) {
  const navigate = useNavigate();

  if (!title) return <LoadingSpinner />;

  const handleClick = () => {
    navigate(`/photograph/${id}`);
  };

  return (
    <div className="photograph-card">
      <header>
        {/* <h3 className="photograph-title" onClick={handleClick}>{title}</h3> */}
        <h3
          className="photograph-title"
          onClick={handleClick}
          dangerouslySetInnerHTML={{ __html: title }}
        />

      </header>
    </div>
  );
}

export default Photographcard;
